import { ReactNode, useState } from "react";
import Chevron from "components/Chevron";
import { colors } from "utils/constants";

interface IMenuSectionProps {
  titleComponent: ReactNode;
  children: ReactNode;
  id?: string;
  preExpanded?: boolean;
  style?: React.CSSProperties;
  expanded?: boolean;
  setExpanded?: (expanded: boolean) => void;
}

const MenuSection = ({
  titleComponent,
  children,
  id,
  preExpanded,
  style,
  expanded,
  setExpanded,
}: IMenuSectionProps) => {
  if (!expanded || !setExpanded) {
    const buildInState = useState(preExpanded);
    expanded = buildInState[0];
    setExpanded = buildInState[1];
  }

  return (
    <div className="menuSection" style={{ width: "100%" }} id={id}>
      <div
        className="sectionTitle noSelect"
        onClick={() => setExpanded?.(!expanded)}
        style={style}
      >
        <div className="titleContainer" style={{ margin: 0 }}>
          {titleComponent}
        </div>

        <Chevron
          direction="down"
          reversed={expanded}
          style={{
            color: colors.primaryBrandGray,
            fontSize: "1em",
            marginRight: "0.5em",
            height: "auto",
            width: '1em',
          }}
        />
      </div>

      <div className="childrenSection">{children}</div>

      <style jsx>{`
        .sectionTitle {
          font-family: "Montserrat", sans-serif !important;
          font-weight: bold;
          text-transform: uppercase;
          text-align: left;
          margin: 0;
          padding: 0.5em 0.5em 0.5em 1em;
          border-radius: 4px;
          width: 100%;
          font-size: 1.2em;
          display: flex;
          justify-content: space-between;
          cursor: pointer;
        }

        .titleContainer,
        .titleContainer p {
          font-weight: 800;
        }

        .childrenSection {
          margin-top: 1em;
          display: ${expanded ? "flex" : "none"};
          flex-direction: column;
        }
      `}</style>
    </div>
  );
};

export default MenuSection;
